<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 网站管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>合作建议</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <div class="handle-box">
				<el-select v-model="query.type" placeholder="请选择类型">
					<el-option key="" label="请选择类型" value=""></el-option>
					<el-option key=0 label="合作" :value=0></el-option>
					<el-option key=1 label="询价" :value=1></el-option>
					<el-option key=2 label="建议" :value=2></el-option>
					<el-option key=3 label="投诉" :value=3></el-option>
				</el-select>&nbsp;
				<el-input v-model="query.tel" placeholder="联系电话" class="handle-input mr10"></el-input>
				
				<el-select v-model="query.dealStatus" placeholder="请选择状态">
					<el-option key="" label="请选择状态" value=""></el-option>
					<el-option key=false label="待处理" :value=false></el-option>
					<el-option key=true label="已处理" :value=true></el-option>
				</el-select>
				&nbsp;
                <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
				<el-button type="primary" icon="el-icon-upload" @click="handleImport" v-if = "controll['import']">导入</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                class="table"
                ref="multipleTable"
                header-cell-class-name="table-header"
				:cell-style="{padding:4+'px'}"
				stripe
            >
				<el-table-column prop="type" label="类型" :formatter = "typeFormat"></el-table-column>
				<el-table-column prop="name" label="用户名"></el-table-column>
				<el-table-column prop="tel" label="联系电话"></el-table-column>
				<el-table-column prop="comNo" label="微信/QQ"></el-table-column>
				<el-table-column prop="dealStatus" label="处理状态" :formatter = "dealStatusFormat"></el-table-column>
				<el-table-column prop="createTime" label="提交时间" width = "160px"></el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
						<el-button
                            type="text"
                            icon="el-icon-view"
                            @click="handleView(scope.$index, scope.row)"
							v-if = "controll['show']"
                        >详情</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-edit"
                            @click="handleDeal(scope.$index, scope.row)"
							v-show = "controll['deal'] && !scope.row.dealStatus"
                        >处理</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>

        <!-- 编辑弹出框 -->
        <el-dialog v-dialogDrag :close-on-click-modal=false :title="title" :visible.sync="editVisible" width="45%">
            <el-form ref="form" :model="form" label-width="100px" :rules="rules">
				<el-row>
					<el-col :span="12">
						<el-form-item label="类型：" prop="type">
							{{typeFormat(null, null, form.type)}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="称呼:" prop="name">
							{{form.name}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="电话:" prop="tel">
							{{form.tel}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="微信/QQ:" prop="comNo">
							{{form.comNo}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="提交内容:" prop="remark">
                    {{form.remark}}
                </el-form-item>
				<el-form-item label="处理结果:" prop="dealRemark">
                    <el-input type=textarea :rows=3 v-model="form.dealRemark"> </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">提交</el-button>
            </span>
        </el-dialog>
		
		<!-- 导入弹出框 -->
        <el-dialog title="导入" :visible.sync="batchVisible" width="50%">
            <el-form ref="batch" :model="batch" label-width="120px" :rules="batchRules">
				<el-form-item label="批量导入数据:" prop="intentions">
                    <el-input type=textarea :rows=10 v-model="batch.intentions"> </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="batchVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveBatch">提交</el-button>
            </span>
        </el-dialog>
		
		<!-- 详情弹出框 -->
        <el-dialog title="详情" :visible.sync="showVisible" width="45%">
            <el-form ref="show" :model="show" label-width="100px">
				<el-row>
					<el-col :span="12">
						<el-form-item label="类型：" prop="type">
							{{typeFormat(null, null, show.type)}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="称呼:" prop="name">
							{{show.name}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="12">
						<el-form-item label="电话:" prop="tel">
							{{show.tel}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="微信/QQ:" prop="comNo">
							{{show.comNo}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="提交内容:" prop="remark">
                    {{show.remark}}
                </el-form-item>
				<el-row>
					<el-col :span="12">
						<el-form-item label="处理状态:" prop="dealStatus">
							{{dealStatusFormat(null, null, show.dealStatus)}}
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="处理时间:" prop="dealTime" v-if="show.dealStatus">
							{{show.dealTime}}
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="处理结果:" prop="dealRemark" v-if="show.dealStatus">
                    {{show.dealRemark}}
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showVisible = false">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { fetchIntentionData, dealIntention, deleteIntention, getIntention, getApplyCompanyList, getEnumValueKV, unlock, importIntention } from '../../../api/index';
export default {
    name: 'intention',
    data() {
        return {
            query: {
                pageNum: 1,
                pageSize: 10
            },
            tableData: [],
            editVisible: false,
			showVisible: false,
            pageTotal: 0,
            form: {},
			show:{},
            idx: -1,
            id: -1,
			title:"",
			rules: {
				dealRemark: [{ required: true, message: '请输入处理结果', trigger: 'blur' }]
            },
			batchRules:{intentions: [{ required: true, message: '导入数据不能为空', trigger: 'blur' }]},
			importIsShow:false,
			batchVisible:false,
			batch:{},
			controll:{}
        };
    },
    created() {
		this.controll = getControll("intention");
        this.getData();
    },
    methods: {
		//状态格式化
		dealStatusFormat(row, column, cellValue) {
			return cellValue ? '已处理' : '待处理';
		},
		typeFormat(row, column, cellValue) {
			if (cellValue == '0') {
				return '合作';
			} else if (cellValue == '1'){
				return '询价';
			} else if (cellValue == '2'){
				return '建议';
			} else if (cellValue == '3'){
				return '头数';
			} else {
				return cellValue;
			}
		},
        // 获取数据
        getData() {
            fetchIntentionData(this.query).then(res => { 
				if (res.code == 0 ) {
					this.tableData = res.data.records;
					this.pageTotal = res.data.total;
				} else {
					this.$message.error("获取数据失败！" + res.message);
				}
            });
        },
        // 触发搜索按钮
        handleSearch() {
            this.$set(this.query, 'pageNum', 1);
			this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },
        // 编辑操作
        handleDeal(index, row) {
            this.idx = index;
			this.title = "处理";
			getIntention(row.id).then(res => {
				if (res.code == 0) {
					this.form = res.data;
					this.editVisible = true;
				} else {
					this.$message.error(`获取数据详情失败！` + res.message);
				}
			})
        },
        // 保存编辑
        saveEdit() {
			this.$refs.form.validate(valid => {
				if (valid) {
					dealIntention(this.form).then(res => {
						if (res.code == 0) {
							this.$message.success('保存成功！');
							this.editVisible = false;
							this.getData();
						} else {
							this.$message.error(`保存失败！` + res.message);
						}
					})
				} else {
					this.$message.error('数据信息不完整！');
				}
			});
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageNum', val);
			this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
		// 详情
		handleView(index, row) {
			this.show = row;
			this.showVisible = true;
		},
		handleImport() {
			this.batch = {};
			this.batchVisible = true;
		},
		saveBatch() {
			importIntention(this.batch.intentions).then(res => {
				if (res.code == 0) {
					this.$message.success('导入成功！');
					this.batchVisible = false;
				} else {
					this.$message.error(`导入失败！` + res.message);
				}
			})
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 180px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
.record-a-d {
	float:left; 
	padding-top:20px;
}
</style>
